import { useState } from "react";
import { useSelector } from "react-redux";
import { Table } from "rsuite";
import { GRAPH_TABLE } from "../../utils/dataconstants";
import { IRoot } from "../../services/interface/IHome";
import { formatNumber } from "../../utils/formatter";

const {Column, HeaderCell, Cell} = Table;

const CustomCell=({rowData, dataKey, ...props}:any)=>{
    return <Cell {...props}>
        {dataKey === "forecastDate" &&  rowData[dataKey]}
        {["processedQty","processedQtyLY","processedQtyL2Y","toolforecast"].includes(dataKey) && 
        `${formatNumber(rowData[dataKey])}`}
    </Cell>
}

export const LineGraphSummary=(props:any)=>{
    return <>
        <div className="table-container h-[90%] flex flex-col">
            <Table
                data={props.data} 
                headerHeight={50}
                cellBordered
                rowClassName={(rowData, rowIndex)=>{
                    return rowIndex%2 === 0 ? 'db-tablebg':''
                }}
            >
            {GRAPH_TABLE?.map((value,index)=>{
                // const width = index === 0 ? 80 : 140;
                return <Column key={value.key} align="left" flexGrow={1}>
                    <HeaderCell className="font-bold">{value?.label}</HeaderCell>
                    <CustomCell dataKey={value.key}></CustomCell>
                </Column>
            })}
            </Table>
        </div>
    </>
}